"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  id: 70,
  name: 'Tropea',
  description: 'Tropea is a world-renowned, award-winning designer of luxury accessories and ready-to-wear. The company, established in 1981, currently produces a range of products under his signature Tropea  Collection. These products include accessories, footwear, watches, jewelry and women’s and men’s ready-to-wear.',
  emojis: '😍😍😍😍😍',
  profileComplete: true,
  alias: 'Tropea',
  links: [],
  city: '17085',
  cityName: 'Miami',
  state: 'FL',
  stateName: 'Florida',
  country: '136',
  countryName: 'United States',
  active: true,
  email: 'meredith@tropea.com',
  governmentId: '',
  coreValues: 'core values',
  foundedYear: '',
  story: '',
  numberOfEmployees: 4,
  photoUrl: 'https://hive-development-files.s3.amazonaws.com/company_70_photo_1611098876.jpg',
  logoUrl: 'https://hive-development-files.s3.amazonaws.com/company_70_logo_1611098868.jpg',
  domain: 'tropea',
  urlTitle: '',
  urlAddress: 'www.tropea.com',
  subsidiaryIndustry: 4,
  internalIndustry: 8,
  type: '8',
  jobFunctions: [{
    id: 4,
    name: 'Analyst'
  }, {
    id: 2,
    name: 'Administrative'
  }],
  hiveCulturalKeywords: [{
    id: 9,
    name: 'Care'
  }, {
    id: 7,
    name: 'Belonging'
  }, {
    id: 9,
    name: 'Care'
  }, {
    id: 2,
    name: 'Accountability'
  }, {
    id: 14,
    name: 'Charity'
  }],
  socialMedias: [{
    id: 1392,
    social: 1,
    title: null,
    url: 'www.linkedin.com/tropea'
  }, {
    id: 1393,
    social: 2,
    title: null,
    url: 'www.intagram.com/tropea'
  }, {
    id: 1393,
    social: 5,
    title: null,
    url: 'www.intagram.com/tropea'
  }],
  internalDivisions: [{
    id: 17,
    social: null,
    title: 'banking',
    url: 'google.com',
    industryId: 9,
    industry: {
      id: 9,
      name: 'Energy & Oil',
      created_at: null,
      updated_at: null,
      parent_id: null
    }
  }, {
    id: 18,
    social: null,
    title: 'banking2',
    url: 'ole.com',
    industryId: 10,
    industry: {
      id: 10,
      name: 'Engineering, Mathematics & Sciences',
      created_at: null,
      updated_at: null,
      parent_id: null
    }
  }],
  subsidiaries: [{
    id: 17,
    social: null,
    title: 'test',
    url: 'test',
    verticalIndustryId: 362,
    verticalIndustry: {
      id: 362,
      name: 'Social Sciences',
      created_at: null,
      updated_at: null,
      parent_id: 10
    },
    industryId: 10,
    industry: {
      id: 10,
      name: 'Engineering, Mathematics & Sciences',
      created_at: null,
      updated_at: null,
      parent_id: null
    }
  }, {
    id: 18,
    social: null,
    title: 'test2',
    url: 'test2',
    verticalIndustryId: 346,
    verticalIndustry: {
      id: 346,
      name: 'Library & Information Services',
      created_at: null,
      updated_at: null,
      parent_id: 8
    },
    industryId: 8,
    industry: {
      id: 8,
      name: 'Education',
      created_at: null,
      updated_at: null,
      parent_id: null
    }
  }],
  videos: [{
    id: 1400,
    social: null,
    title: 'test',
    url: 'https://hive-development-files.s3.amazonaws.com/company_70_video_1611688723_1611688723.png',
    fileName: '7A715AD8-449D-4B5A-ABA2C5D92D9B5A21_source.png'
  }, {
    fileName: 'Screen Recording 2021-01-26 at 14.58.37.mov',
    id: 1314,
    social: null,
    title: 'otro video',
    url: 'https://hive-development-files.s3.amazonaws.com/company_51_video_1611684088_1611684088.mov'
  }],
  recentPress: [{
    id: 1398,
    social: null,
    title: 'This is my text for recent press 2',
    url: 'www.recentpress2.com'
  }],
  recentCommitments: [{
    id: 1399,
    social: null,
    title: 'This is my text for recent commitment',
    url: 'www.recentcommitments.com'
  }],
  influencers: [{
    name: 'Pol',
    handle: 'Poly',
    url: 'www.poly.com',
    socialNetwork: 4
  }, {
    name: 'Pain',
    handle: 'Pain',
    url: 'www.pain.com',
    socialNetwork: 1
  }],
  mission: 'This is my mission statement 1',
  missionLink: '',
  diversityMean: 'Diversity means to us - Menswear is an innovative collection with a modern American style—cool, sporty, sophisticated. Its signature sensibility is rooted in rich sportswear, sleek tailoring and essential luxury. It offers the perfect balance of polish and ease, with silhouettes that are casual yet luxurious, comfortable yet sharp, urban yet rugged.',
  diversityMeanLink: 'www.diversity.com',
  talent: 'This is my next gen of talent statemnt',
  talentLink: 'www.nextgen.com',
  talentGuide: 'This is my next gen of talent I think this is duplicated',
  talentGuideLink: '',
  diversity: 'This is my text for diversity inclusion efforts',
  diversityLink: 'www.effort.com',
  internalGroups: 'This is my text for internal groups',
  internalGroupsLink: 'www.internalgroup.com',
  undergraduate: 'This is my text for undegraduate recruiting',
  undergraduateLink: 'www.recruiting.com',
  recruit: 'When and how do ',
  careerRunways: 'How to press & succeed',
  interviewStyles: 'How to press & succedd: INTERVIEW ',
  internships: '',
  contactPoint: 'International',
  phone: '(214)789-8978',
  address: '701 N Polk St, Little Rock, AR 72205, Estados Unidos',
  firstName: 'Meredith',
  lastName: 'Grey',
  aggregateDataHive: true,
  aggregateDataFallowers: 'Yes ',
  culture: 'Hello, this is my people of culture description',
  cultureCaption: 'This is the text for People of culture',
  cultureImageUrl: null,
  hiveCulturalKeywordsUrl: 'www.keywords.com',
  socialImpact: 'This is my social impact text',
  socialImpactLink: 'www.socialimpact.com',
  socialImpactImageUrl: null,
  welcome: 'Primary welcome from ceo',
  welcomeImageUrl: 'https://hive-development-files.s3.amazonaws.com/company_70_welcome_image_url_1611687628.png',
  welcomeImageFileName: 'welcome_image.png',
  totalOpportunities: 2,
  followers: 1,
  followersSinceLastLogin: 0,
  followersPerDiversities: [],
  overallShortStatement: 'OVERALL SHORT STATEMENT - Behind this burgeoning empire stands a singular designer with an innate sense of glamour and an unfailing eye for timeless chic. Tropea  has won numerous accolades within the fashion industry, been honored for his philanthropy, and earned the respect and affection of millions. Wholly dedicated to a vision of style that is as sophisticated as it is indulgent, as iconic as it is modern, he has created an enduring luxury lifestyle empire with a global reach.',
  headquarterLocation: {
    stateCode: 'AZ',
    state: {
      id: null,
      name: 'Arizona'
    },
    city: {
      id: 449,
      city: 'Alpine',
      state_code: 'AZ'
    },
    cityId: '449',
    cityName: '',
    country: null,
    countryId: null,
    countryName: '',
    international: false
  },
  companyLocations: [],
  linkedin: '',
  twitter: '',
  facebook: '',
  instagram: '',
  other: '',
  additionalLocations: [{
    stateCode: 'AK',
    state: {
      id: null,
      name: 'Alaska'
    },
    city: {
      id: 208,
      city: 'Alakanuk',
      state_code: 'AK'
    },
    cityId: '208',
    cityName: '',
    country: null,
    countryId: null,
    countryName: '',
    international: false
  }, {
    stateCode: '',
    state: null,
    city: null,
    cityId: '',
    cityName: 'another city',
    country: {
      id: 9,
      country: 'Bahrain',
      created_at: null,
      updated_at: null
    },
    countryId: '9',
    countryName: '',
    international: true
  }, {
    stateCode: '',
    state: null,
    city: null,
    cityId: '',
    cityName: 'sadsa',
    country: {
      id: 11,
      country: 'Belarus',
      created_at: null,
      updated_at: null
    },
    countryId: '11',
    countryName: 'another country',
    international: true
  }],
  industries: [{
    vertical: {
      id: 8,
      name: 'Education',
      created_at: null,
      updated_at: null,
      parent_id: null
    },
    industry: {
      id: 341,
      name: 'E-Learning',
      created_at: null,
      updated_at: null,
      parent_id: 8
    }
  }, {
    vertical: {
      id: 8,
      name: 'Education',
      created_at: null,
      updated_at: null,
      parent_id: null
    },
    industry: {
      id: 345,
      name: 'Libraries',
      created_at: null,
      updated_at: null,
      parent_id: 8
    }
  }, {
    vertical: {
      id: 18,
      name: 'Law',
      created_at: null,
      updated_at: null,
      parent_id: null
    },
    industry: {
      id: 442,
      name: 'Law',
      created_at: null,
      updated_at: null,
      parent_id: 18
    }
  }],
  pointOfContact: {
    stateCode: 'CA',
    state: {
      name: 'California',
      state_code: 'CA'
    },
    city: {
      id: 193,
      city: 'Akiachak',
      state_code: 'AK'
    },
    cityId: '193',
    cityName: 'hh',
    country: {
      id: 3,
      country: 'Angola',
      created_at: null,
      updated_at: null
    },
    countryId: 3,
    countryName: null,
    international: true,
    firstName: 'b',
    lastName: 'd',
    address: 'c',
    phone: 'a',
    email: 'f',
    companyEmailDomain: 'e'
  }
};
exports.default = _default;